export const PLACEHOLDER_TEXT = 'Enter Template description...';

export const DESCRIPTION_REQUIRED = 'Description cannot be empty';
